import { render, staticRenderFns } from "./basicuserjk.vue?vue&type=template&id=1fc681d8&"
import script from "./basicuserjk.vue?vue&type=script&lang=js&"
export * from "./basicuserjk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports